export default {
  common: {
    save: 'Enregistrer',
    cancel: 'Annuler',
    confirm: 'Confirmer',
    delete: 'Supprimer',
    edit: 'Modifier',
    view: 'Voir',
    back: 'Retour',
    close: 'Fermer',
    add: 'Ajouter',
    send: 'Envoyer',
    sending: 'Envoi...',
    saving: 'Enregistrement...',
    loading: 'Chargement...',
    search: 'Rechercher',
    update: 'Mettre à jour',
    create: 'Créer',
    creating: 'Création...',
    transfer: 'Transférer',
    approve: 'Approuver',
    reject: 'Rejeter',
    ok: 'Compris',
    name: 'Nom',
    username: 'Nom d\'utilisateur',
    password: 'Mot de passe',
    email: 'E-mail',
    date: 'Date',
    status: 'Statut',
    type: 'Type',
    quantity: 'Quantité',
    description: 'Description',
    project: 'Projet',
    task: 'Tâche',
    logout: 'Déconnexion',
    notifications: 'Notifications',
    settings: 'Paramètres',
    draft: 'Brouillon',
    sent: 'Envoyé',
    active: 'Actif',
    inactive: 'Inactif',
    priority: 'Priorité',
    language: 'Langue',
    yes: 'Oui',
    no: 'Non',
    error: 'Erreur',
    success: 'Succès',
    warning: 'Attention',
    required: 'Obligatoire',
    optional: 'Facultatif',
    all: 'Tous',
    none: 'Aucun',
    upload: 'Téléverser un fichier',
    download: 'Télécharger',
    print: 'Imprimer',
    actions: 'Actions',
    details: 'Détails',
    filters: 'Filtres',
    results: 'Résultats',
    noResults: 'Aucun résultat trouvé',
    total: 'Total',
    of: 'sur',
    verified: 'vérifié',
    pending: 'En attente',
    completed: 'Terminé',
    cancelled: 'Annulé',
  },

  auth: {
    login: 'Se connecter',
    loginTitle: 'Connexion à votre compte',
    logout: 'Déconnexion',
    register: 'S\'inscrire',
    forgotPassword: 'Mot de passe oublié ?',
    resetPassword: 'Réinitialiser le mot de passe',
    usernameOrEmail: 'Nom d\'utilisateur ou e-mail',
    enterPassword: 'Entrez votre mot de passe',
    enterUsername: 'Entrez votre nom d\'utilisateur',
    loginError: 'Nom d\'utilisateur ou mot de passe incorrect.',
    sessionExpired: 'Session expirée. Veuillez vous reconnecter.',
  },

  nav: {
    dashboard: 'Tableau de bord',
    overview: 'Vue d\'ensemble',
    documents: 'Documents',
    viewDocuments: 'Voir les documents',
    manageProjects: 'Gérer les projets',
    viewProjects: 'Voir les projets',
    manageUsers: 'Gérer les utilisateurs',
    viewUsers: 'Voir les utilisateurs',
    manageWarehouse: 'Gérer l\'entrepôt',
    viewWarehouse: 'Voir l\'entrepôt',
    manageMachinery: 'Gérer les machines',
    viewMachinery: 'Voir les machines',
    manageSystem: 'Gérer le système',
    projects: 'Projets',
    myProjects: 'Mes projets',
    myTasks: 'Mes tâches',
    reports: 'Rapports',
    drawings: 'Plans',
    warehouse: 'Entrepôt',
    checkStock: 'Consulter le stock',
    requests: 'Demandes',
    requestItem: 'Demander un article',
    tickets: 'Tickets',
    messages: 'Messages',
    adminMode: 'Mode administrateur',
    standardMode: 'Mode standard',
    analystMode: 'Mode analyste',
    createReport: 'Créer un rapport',
    createReports: 'Rapports de chantier',
    dailyReport: 'Rapport journalier de chantier',
    incidentReport: 'Rapport d\'incident',
    safetySection: 'Sécurité du travail',
    safetyDialog: 'Dialogues de sécurité',
    workPermit: 'Permis de travail critique',
    occurrenceReport: 'Rapport d\'occurrence',
    settingsMenu: 'Paramètres',
  },

  profile: {
    editProfile: 'Modifier le profil',
    displayName: 'Nom',
    usernameLabel: 'Nom d\'utilisateur',
    passwordLabel: 'Mot de passe',
    changePassword: 'Changer le mot de passe',
    appearance: 'Apparence',
    lightMode: 'Mode clair',
    darkMode: 'Mode sombre',
    languageLabel: 'Langue',
    cropTitle: 'Recadrer la photo de profil',
    cropUse: 'Utiliser cette zone',
    zoom: 'Zoom',
    currentPassword: 'Confirmer le mot de passe actuel',
    newPassword: 'Nouveau mot de passe',
    confirmNewPassword: 'Confirmer le nouveau mot de passe',
    emailVerified: 'vérifié',
    emailChange: 'Modifier',
    emailSendCode: 'Envoyer le code',
    emailConfirm: 'Confirmer',
    emailResend: '← Renvoyer le code',
    emailCancelChange: 'Annuler',
    emailSending: 'Envoi...',
    emailVerifying: 'Vérification...',
    emailHint: 'Code envoyé à {email}. Vérifiez votre boîte de réception et spam.',
    emailSuccess: 'E-mail {email} vérifié avec succès.',
    emailInvalidError: 'Veuillez entrer un e-mail valide.',
    emailGenericError: 'Erreur lors de l\'envoi du code.',
    emailInvalidCode: 'Code invalide.',
    passwordFillAll: 'Veuillez remplir tous les champs de mot de passe.',
    passwordWrong: 'Le mot de passe actuel est incorrect.',
    passwordMismatch: 'La confirmation du mot de passe ne correspond pas.',
    saveFillAll: 'Veuillez remplir le nom et le nom d\'utilisateur.',
    saveFinishPassword: 'Finalisez ou annulez le changement de mot de passe avant d\'enregistrer.',
    avatarAlt: 'profil',
  },

  dashboard: {
    overview: 'Vue d\'ensemble',
    myProjects: 'Mes projets',
    myTasks: 'Mes tâches',
    activeProjects: 'Projets actifs',
    completedTasks: 'Tâches terminées',
    pendingTasks: 'Tâches en attente',
    recentActivity: 'Activité récente',
    noProjects: 'Aucun projet trouvé.',
    noTasks: 'Aucune tâche trouvée.',
    createProject: 'Créer un projet',
    projectName: 'Nom du projet',
    startDate: 'Date de début',
    endDate: 'Date de fin',
  },

  projects: {
    title: 'Projets',
    newProject: 'Nouveau projet',
    projectName: 'Nom du projet',
    startDate: 'Début',
    endDate: 'Fin',
    progress: 'Avancement',
    team: 'Équipe',
    gantt: 'Planning',
    files: 'Fichiers',
    tickets: 'Tickets',
    warehouse: 'Entrepôt',
    dds: 'Causerie sécurité',
    reports: 'Rapports',
    noProjects: 'Aucun projet.',
    deleteConfirm: 'Êtes-vous sûr de vouloir supprimer ce projet ?',
  },

  tasks: {
    title: 'Tâches',
    newTask: 'Nouvelle tâche',
    taskName: 'Nom de la tâche',
    assignee: 'Responsable',
    dependencies: 'Dépendances',
    duration: 'Durée (jours)',
    startDate: 'Début',
    endDate: 'Fin',
    progress: 'Avancement',
    addProgress: 'Enregistrer l\'avancement',
    noTasks: 'Aucune tâche.',
    blocked: 'Bloquée',
    inProgress: 'En cours',
    done: 'Terminée',
    deleteConfirm: 'Supprimer cette tâche ?',
  },

  warehouse: {
    title: 'Entrepôt',
    stock: 'Stock',
    requestItem: 'Demander un article',
    requests: 'Demandes',
    addItem: 'Ajouter un article',
    itemName: 'Nom de l\'article',
    category: 'Catégorie',
    unit: 'Unité',
    available: 'Disponible',
    reserved: 'Réservé',
    transferItem: 'Transférer un article',
    reportDamage: 'Signaler un dommage',
    provideEquipment: 'Fournir du matériel',
    noItems: 'Aucun article en stock.',
    noRequests: 'Aucune demande.',
    approveRequest: 'Approuver la demande',
    rejectRequest: 'Rejeter la demande',
    requestStatus: {
      pending: 'En attente',
      approved: 'Approuvé',
      rejected: 'Rejeté',
      delivered: 'Livré',
    },
  },

  safety: {
    title: 'Sécurité',
    dds: 'Causerie sécurité',
    ddsTitle: 'Dialogue quotidien de sécurité',
    newDds: 'Nouvelle causerie',
    occurrences: 'Occurrences',
    permits: 'Permis',
    createDialog: 'Créer un dialogue',
    createOccurrence: 'Enregistrer une occurrence',
    createPermit: 'Créer un permis',
    topic: 'Thème',
    presenter: 'Présentateur',
    attendees: 'Participants',
    date: 'Date',
    noSafety: 'Aucun enregistrement de sécurité.',
  },

  tickets: {
    title: 'Tickets',
    newTicket: 'Nouveau ticket',
    subject: 'Sujet',
    category: 'Catégorie',
    openedBy: 'Ouvert par',
    assignedTo: 'Assigné à',
    openTickets: 'Tickets ouverts',
    closedTickets: 'Tickets fermés',
    noTickets: 'Aucun ticket.',
    status: {
      open: 'Ouvert',
      inProgress: 'En cours',
      closed: 'Fermé',
    },
  },

  users: {
    title: 'Utilisateurs',
    newUser: 'Nouvel utilisateur',
    role: 'Rôle',
    roles: {
      adminMaster: 'Administrateur principal',
      adminObra: 'Admin chantier',
      user: 'Utilisateur',
    },
    noUsers: 'Aucun utilisateur.',
    deleteConfirm: 'Supprimer cet utilisateur ?',
    manageRoles: 'Gérer les rôles',
    manageUsers: 'Gestion des utilisateurs',
    userList: 'Liste des utilisateurs',
  },

  system: {
    title: 'Paramètres du système',
    siteName: 'Nom du système',
    logo: 'Logo',
    loginBackground: 'Arrière-plan de connexion',
    primaryColor: 'Couleur principale',
    save: 'Enregistrer les paramètres',
    saved: 'Paramètres enregistrés.',
  },

  reports: {
    title: 'Rapports',
    daily: 'Rapport journalier',
    incident: 'Rapport d\'incident',
    noReports: 'Aucun rapport.',
    createReport: 'Créer un rapport',
    date: 'Date',
    author: 'Auteur',
    content: 'Contenu',
  },

  machinery: {
    title: 'Engins lourds',
    newMachine: 'Nouvel engin',
    machineName: 'Nom',
    model: 'Modèle',
    plate: 'Immatriculation',
    status: 'Statut',
    noMachinery: 'Aucun engin.',
  },

  messenger: {
    title: 'Messages',
    newMessage: 'Nouveau message',
    noMessages: 'Aucun message.',
    typeMessage: 'Saisir un message...',
    send: 'Envoyer',
  },
}
